import { themeColors } from '@/config/theme/themeColors.ts';

export const processCreateDialogStyles = {
  fieldset: {
    border: 0,
    m: 0,
    p: 0,
  },
  matchOptions: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 1.5,
    overflowX: 'auto',
    pb: 1,
  },
  /** A match whose customer cannot become the customer of a process stays listed but greyed out. */
  matchOption: (isSelected: boolean, isSelectable: boolean) => ({
    '&:hover': {
      borderColor: isSelectable ? themeColors.accentColorLight : themeColors.stroke,
    },
    '&.Mui-disabled': {
      bgcolor: 'action.hover',
      color: 'text.disabled',
    },
    border: `2px solid ${isSelected ? themeColors.accentColor : themeColors.stroke}`,
    borderRadius: 1,
    flexShrink: 0,
    minWidth: 200,
    p: 1.5,
    textAlign: 'left',
  }),
};
